const maintenancePages = [] as string[]

export default class MaintenanceService {
  pageMaintenanceMode(pageName) {
    return maintenancePages.includes(pageName)
  }
}
